/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { callIfScrollToBottom } from '../../utils/helpers/scroll'
import { useBackgroundStyle } from '../../utils/styles/background'
import { useBorderStyle } from '../../utils/styles/border'
import { useCursorStyle } from '../../utils/styles/cursor'
import { useDisplayStyle } from '../../utils/styles/display'
import { useGridStyle } from '../../utils/styles/grid'
import { useMarginStyle } from '../../utils/styles/margin'
import { usePaddingStyle } from '../../utils/styles/padding'
import { useScrollStyle } from '../../utils/styles/scroll'
import { useSizeStyle } from '../../utils/styles/size'
import ConditionalLink from '../actions/ConditionalLink'

const Panel = ({ children, onScrollToBottom, onClick, ...props }) => {
  const style = css`
    ${useGridStyle(props)}
    ${useSizeStyle(props)}
    ${useScrollStyle(props)}
    ${useBackgroundStyle({ bgColor: 'white', ...props })}
    ${useBorderStyle({ radius: 0.5, borderColor: 'light3', ...props })}
    ${usePaddingStyle({ padding: 1.25, ...props })}
    ${useMarginStyle(props)}
    ${useCursorStyle(props)}
    ${useDisplayStyle(props)}
  `

  return (
    <ConditionalLink onClick={onClick} block width="100%">
      <div className="panel" css={style} onScroll={callIfScrollToBottom(onScrollToBottom)} {...props}>
        {children}
      </div>
    </ConditionalLink>
  )
}

export default Panel
